import React, { useMemo } from 'react';
import { usePersistedSessionState } from '@edreamsodigeo/frontend-core';
import { SessionContext } from 'context';

const STORAGE_KEY = 'cabin-bags:sessionState';

export function SessionProvider({ children }) {
  const [value, setValue] = usePersistedSessionState(STORAGE_KEY);

  const session = useMemo(() => {
    return [value || {}, setValue];
  }, [value, setValue]);

  return (
    <SessionContext.Provider value={session}>
      {children}
    </SessionContext.Provider>
  );
}
